import { WORKOUT_EXERCISE_KEY } from '../../../model'
import { SET_DATA_KEY } from '../../../model/constants'
import { getEstimatedRateOfPerceivedExertionSetDataUtil } from '../../../model/utils'

import getByExerciseIdExerciseLogSummarySelector from '../../../../exercise-log-summaries/selectors/get-by-exercise-id'
import getByIdExerciseSelector from '../../../../exercise/redux/selectors/get-by-id'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import updateWorkoutExerciseAction from '../update'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import getCurrentWorkoutExerciseSelect from '../../selectors/get-current'
import getCurrentSetIndexWorkoutExerciseSelect from '../../selectors/get-current-set-index'
import getByIdWorkoutSectionSelector from '../../../../workout-section/redux/selectors/get-by-id'
import setUtil from '../../../../../utils/set'
import { isEqualUtil, omitObjectUtil } from 'packages/src'

function updateSetWorkoutExerciseAction (params) {
  return async (dispatch, getState) => {
    let {
      set,
      key,
      shouldNotSave,
      omitWorkoutUpdate
    } = params

    // [noop] if the workout exercise is not available
    const workoutExercise = (
      params.workoutExercise || getCurrentWorkoutExerciseSelect(getState())
    )

    if (!workoutExercise) {
      return
    }

    const exercise = getByIdExerciseSelector(getValueReduxUtil(workoutExercise,
      WORKOUT_EXERCISE_KEY.EXERCISE_ID
    ))(getState())
    const exerciseLogSummary = (
      getByExerciseIdExerciseLogSummarySelector(getIdReduxUtil(exercise))(
        getState())
    )
    const estimatedRpe = getEstimatedRateOfPerceivedExertionSetDataUtil({
      exerciseLogSummary,
      workoutSection: getByIdWorkoutSectionSelector(getValueReduxUtil(
        workoutExercise,
        WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID
      ))(getState()),
      exercise,
      set
    })

    if (estimatedRpe) {
      set = setUtil(set,
        SET_DATA_KEY.ESTIMATED_RATE_OF_PERCEIVED_EXERTION,
        estimatedRpe
      )
    }

    let index = params.index
    if (index == null) {
      index = getCurrentSetIndexWorkoutExerciseSelect(getState())
    }

    // Update the set and all the future ones
    const setData = getValueReduxUtil(workoutExercise,
      WORKOUT_EXERCISE_KEY.SET_DATA
    )
    const isUpdatingTimeElapsed = key === SET_DATA_KEY.TIME_ELAPSED
    const isUpdatingNotes = key === SET_DATA_KEY.NOTES
    const beforeUpdateSet = setData[index]
    const isConvertingNormalSetToRest = (
      beforeUpdateSet &&
      beforeUpdateSet[SET_DATA_KEY.REST] ==
      null &&
      key ===
      SET_DATA_KEY.REST
    )
    const isConvertingRestToNormalSet = (
      beforeUpdateSet &&
      beforeUpdateSet[SET_DATA_KEY.REST] !=
      null &&
      key !==
      SET_DATA_KEY.REST
    )
    const keysToOmitForComparison = [
      SET_DATA_KEY.NOTES,
      SET_DATA_KEY.TIME_ELAPSED
    ]
    const newSetData = setData.map((setItem, i) => {
      if (index === i) {
        return {
          ...set
        }
      } else if ((
        i > index
      ) && // Update the future sets if:
        // - it's not a note update
        !isUpdatingNotes && // - it's not converting to a rest
        !isConvertingNormalSetToRest &&
        // - it's not converting a rest to a normal set
        !isConvertingRestToNormalSet && // - it's not a time elapsed update
        !isUpdatingTimeElapsed &&
        // - if they have the exact same content: reps, weight...
        isEqualUtil(omitObjectUtil(setItem, keysToOmitForComparison),
          omitObjectUtil(beforeUpdateSet, keysToOmitForComparison)
        )) {
        return {
          ...omitObjectUtil(set, keysToOmitForComparison),
          [SET_DATA_KEY.NOTES]: setItem[SET_DATA_KEY.NOTES],
          [SET_DATA_KEY.TIME_ELAPSED]: setItem[SET_DATA_KEY.TIME_ELAPSED]
        }
      }
      return { ...setItem }
    })

    dispatch(updateWorkoutExerciseAction({
      type: WORKOUT_EXERCISES_ACTION.UPDATE_SET,
      payload: {
        path: getPathReduxUtil(workoutExercise),
        key: WORKOUT_EXERCISE_KEY.SET_DATA,
        value: newSetData,
        shouldNotSave,
        omitWorkoutUpdate
      }
    }))
  }
}

export default updateSetWorkoutExerciseAction
